import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import AppBar from '@mui/material/AppBar';
import store from 'app/store';
import Tooltip from '@mui/material/Tooltip';
import ErrorBoundary from '../ErrorBoundary';
import { useTranslation } from 'react-i18next';
import OriginalJobLabel from 'app/main/loadz/components/OriginalJobLabel';
import ErrorIcon from '@mui/icons-material/Error';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { formatCurrency } from '../../../utils/numberFormatting';

const classes = {
  paper: {
    border: 'none',
    boxShadow: 'none',
    height: '80%',
    width: '95%',
    padding: 0,
    //backgroundColor: '#2549d9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
  },
  blank: {
    height: '0%',
    width: '0%',
    padding: 0,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'none',
  },
};

var ReportData = [];
/**
 * [
 * {
 *      name
 *      id
 *      time_data:fake array[{name, days,[{shifts}]}]
 *      earnings_data:[{job_no, [{tickets in the job_no}]}]
 *      day_totals:[{day:'sunday', sunday:'10:10'},{day:'monday', monday:'10:10'}]
 * }
 * ]
 */

// Helper function to format time with red color and error icon when hours >= 12
const formatTimeWithWarning = (timeString) => {
  if (!timeString || timeString === '00:00') return timeString;

  const hours = parseInt(timeString.split(':')[0]);
  const isWarning = hours >= 14;

  if (isWarning) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', color: 'red' }}>
        <Typography sx={{ color: 'red', fontSize: 'inherit' }}>
          {timeString}
        </Typography>
        <Tooltip title='Update Timesheet' arrow>
          <ErrorIcon sx={{ fontSize: 11, marginLeft: 0.5, color: 'red' }} />
        </Tooltip>
      </Box>
    );
  }

  return timeString;
};

/** Normalize HH:mm for report cells; bad/undefined values → end-of-day duration 23:59 */
function sanitizeReportDuration(timeString, fallback = '23:59') {
  if (
    timeString == null ||
    timeString === false ||
    timeString === 'null' ||
    timeString === 'undefined:undefined' ||
    String(timeString).includes('undefined') ||
    String(timeString).includes('Invalid') ||
    String(timeString).includes('NaN')
  ) {
    return fallback;
  }
  const parts = String(timeString).split(':');
  if (parts.length < 2 || parts[0] === '' || parts[1] === '' || parts[0] === 'undefined' || parts[1] === 'undefined') {
    return fallback;
  }
  if (!Number.isFinite(Number(parts[0])) || !Number.isFinite(Number(parts[1]))) {
    return fallback;
  }
  const h = String(parts[0]).padStart(2, '0');
  const m = String(parts[1]).padStart(2, '0');
  return `${h}:${m}`;
}

function sanitizeReportClockLabel(label, fallback) {
  if (
    label == null ||
    label === '' ||
    label === 'Invalid date' ||
    String(label).includes('Invalid') ||
    String(label).includes('undefined') ||
    String(label).includes('NaN')
  ) {
    return fallback;
  }
  return label;
}

function formatDriveTimeParts(driveTime) {
  if (driveTime == null || driveTime === false || driveTime === '') {
    return null;
  }
  const parts = String(driveTime).split(':');
  if (parts.length < 2 || parts[0] === 'undefined' || parts[1] === 'undefined') {
    return null;
  }
  const h = parts[0];
  const m = parts[1];
  if (!Number.isFinite(Number(h)) || !Number.isFinite(Number(m))) {
    return null;
  }
  return (
    (String(h).length == 1 ? '0' + h : h) +
    ':' +
    (String(m).length == 1 ? '0' + m : m)
  );
}

/** Zero-pad HH or MM for display; null/undefined → '00' */
function padTimePart(value, fallback = '00') {
  if (value == null || value === '' || Number.isNaN(Number(value))) {
    return fallback;
  }
  const str = String(value);
  return str.length === 1 ? `0${str}` : str;
}

const createData = (earnings, timesheets, batch_access) => {
  var general_obj = {};

  var data = [];
  var time_data = [];
  console.log('start of createData function');
  console.log('data 1', earnings);
  console.log('data 2', timesheets);
  console.log('data 3', batch_access);
  console.log('end of createData function');
  //date
  if (
    earnings?.batches?.at(batch_access)?.batch.commission &&
    earnings?.batches?.at(batch_access)?.batch?.commission.date
  ) {
    for (const day of earnings.batches.at(batch_access).batch.commission.date) {
      for (const job of earnings.batches.at(batch_access).batch.commission[day]
        .job_no) {
        const found = data.find((elem) => elem.job_no == job);
        if (found) {
          const idx = data.indexOf(found);
          const job_access = data[idx].job_no;

          for (const tk of earnings.batches.at(batch_access).batch.commission[
            day
          ][job].tk_no) {
            data[idx][job_access].push(
              earnings.batches.at(batch_access).batch.commission[day][job][tk]
            );
          }
        } else {
          const newjob = {};
          newjob.job_no = job;
          newjob.details =
            earnings.batches.at(batch_access).batch.commission[day][
              job
            ].details;

          newjob[job] = [];
          for (const tk of earnings.batches.at(batch_access).batch.commission[
            day
          ][job].tk_no) {
            newjob[job].push(
              earnings.batches.at(batch_access).batch.commission[day][job][tk]
            );
          }

          data.push(newjob);
        }
      }
    }
  }

  var newtime = {};
  newtime.days = timesheets?.batches?.at(0)?.days;
  newtime.name = timesheets?.name;

  if (timesheets?.batches.at(0)?.batch?.shift_data) {
    if (timesheets?.batches?.at(0)?.batch?.shift_data.date) {
      newtime.shifts = [];

      for (const day of timesheets?.batches?.at(0)?.batch?.shift_data.date) {
        for (const shift of timesheets?.batches?.at(0)?.batch.shift_data[day]) {
          newtime.shifts.push(shift);
        }
      }
    } else {
      newtime.shifts = false;
    }
  } else {
    newtime.shifts = false;
  }

  time_data.push(newtime);

  for (const elem of data) {
    var job_total = 0;
    for (const job of elem[elem.job_no]) {
      job_total = job_total + +job.commission;
    }
    elem.total = job_total.toFixed(2);
  }

  if (timesheets?.batches?.at(0)?.batch?.rate) {
    general_obj.complogo = timesheets?.complogo;
    general_obj.driver_address = timesheets?.driver_address;
    general_obj.commission_percent = timesheets?.commission_percent
      ? timesheets?.commission_percent + '%'
      : 0 + '%';
    general_obj.name = timesheets?.name;
    const batch_access_data = timesheets?.batches?.at(0);
    general_obj.ot_hours = batch_access_data?.batch?.ot_hours ?? 0;
    general_obj.ot_minutes = batch_access_data?.batch?.ot_minutes ?? 0;
    general_obj.ot_pay = batch_access_data?.batch?.ot_pay ?? 0;
    general_obj.total_pay = batch_access_data?.batch?.pay ?? 0;
    general_obj.rate = batch_access_data?.batch?.rate ?? 0;
    general_obj.reg_hours = batch_access_data?.batch?.regular_hours ?? 0;
    general_obj.reg_minutes = batch_access_data?.batch?.regular_minutes ?? 0;
    general_obj.commission_total =
      earnings.batches.at(batch_access).commission_total;
    general_obj.data = data;
    general_obj.total_hours = batch_access_data?.batch?.total_hours || '00:00';
    general_obj.drive_time = batch_access_data?.batch?.drive_time ?? false;
    general_obj.time_data = time_data;
    general_obj.day_summary = batch_access_data?.day_summary;
    general_obj.days = batch_access_data.days;
    general_obj.additions =
      earnings?.batches?.at(batch_access)?.batch.additions;
    general_obj.additions_total =
      +earnings?.batches?.at(batch_access)?.batch.additions_total;
    general_obj.net_money =
      earnings?.batches?.at(batch_access)?.batch?.net_money == undefined
        ? 0
        : +earnings?.batches?.at(batch_access)?.batch.net_money;
    general_obj.first_shift =
      earnings?.batches?.at(batch_access)?.batch?.first_shift;

    general_obj.deductions =
      earnings?.batches?.at(batch_access)?.batch?.deductions;
    general_obj.deductions_total =
      +earnings?.batches?.at(batch_access)?.batch?.deductions_total;
  } else {
    general_obj.complogo = timesheets?.complogo;
    general_obj.driver_address = timesheets?.driver_address;
    general_obj.commission_percent = timesheets?.commission_percent
      ? timesheets?.commission_percent + '%'
      : 0 + '%';
    general_obj.name = timesheets?.name;
    general_obj.ot_hours = '00';
    general_obj.ot_minutes = '00';
    general_obj.ot_pay = 0;
    general_obj.total_pay = 0;
    general_obj.rate = timesheets?.batches?.at(0)?.rate;
    general_obj.reg_hours = 0;
    general_obj.reg_minutes = 0;
    general_obj.commission_total =
      earnings?.batches?.at(batch_access)?.commission_total;
    general_obj.data = data;
    general_obj.total_hours = '00:00';
    general_obj.drive_time = false;
    general_obj.time_data = time_data;
    const batch_access_data = timesheets?.batches?.at(0);
    general_obj.day_summary = batch_access_data?.day_summary;
    general_obj.days = batch_access_data?.days;
    general_obj.additions = earnings.batches.at(batch_access).batch.additions;
    general_obj.additions_total =
      +earnings?.batches?.at(batch_access)?.batch?.additions_total;
    general_obj.net_money =
      earnings?.batches?.at(batch_access)?.batch?.net_money == undefined
        ? 0
        : +earnings?.batches?.at(batch_access)?.batch.net_money;
    general_obj.first_shift =
      earnings?.batches?.at(batch_access)?.batch?.first_shift;

    general_obj.deductions =
      earnings?.batches?.at(batch_access)?.batch?.deductions;
    general_obj.deductions_total =
      +earnings?.batches?.at(batch_access)?.batch?.deductions_total;
  }

  ReportData.push(general_obj);
};

// Helper function to calculate wait time earnings
// Wait time earnings = (wait_time_hours * wait_rate + wait_time_minutes * (wait_rate/60)) * commission_rate
// If wait_time_earnings is not provided, we calculate it as approximately 25% of wait charge
const calculateWaitTimeEarnings = (
  waitTimeDuration,
  commissionPercent,
  waitRate
) => {
  if (!waitTimeDuration) return '0.00';

  // Parse Hrs:MM format
  const timeParts = waitTimeDuration.split(':');
  const hours = parseInt(timeParts[0]) || 0;
  const minutes = parseInt(timeParts[1]) || 0;

  // If wait_rate is provided, use it; otherwise estimate
  const rate = waitRate || 0;
  const commissionRate = commissionPercent
    ? parseFloat(commissionPercent.replace('%', '')) / 100
    : 0.25; // Default to 25%

  // Calculate wait charge: hours * rate + minutes * (rate/60)
  const waitCharge = hours * rate + minutes * (rate / 60);

  // Calculate driver earnings: wait charge * commission rate
  const earnings = waitCharge * commissionRate;

  return earnings.toFixed(2);
};

const JobTable = ({ data }) => {
  //data holds the sub tables data.details.og_job_no and data.details.og_comp
  const { t } = useTranslation('navigation');

  var job_total = 0;
  return (
    <div className='flex flex-col items-center justify-center'>
      <Box width={684} sx={{ marginTop: 1 }}>
        {data.map((elem, i) => {
          return (
            <ErrorBoundary>
              <Box
                className='job'
                border={2}
                borderBottom={0}
                sx={{ marginBottom: 1 }}
                key={i}
              >
                <div
                  className='earning-job-title'
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    minHeight: 36,
                    height: 'auto',
                    position: 'relative',
                    zIndex: 0,
                    backgroundColor: '#ffffff',
                    boxSizing: 'border-box',
                    padding: '6px 8px 6px 0',
                  }}
                >
                  <div
                    style={{
                      paddingLeft: '25px',
                      marginRight: '16px',
                      flex: '1 1 auto',
                    }}
                  >
                    <Typography fontWeight={'bold'} fontSize={17}>
                      {elem.job_no} &nbsp; {elem.details.destination} &nbsp;{' '}
                      {elem.details.commissions ? null : '(pay by the hour)'}
                    </Typography>
                    <OriginalJobLabel job={elem.details} variant='subtle' />
                  </div>

                  <div style={{ width: '150px', flex: '0 0 auto', textAlign: 'right' }}>
                    <Typography fontWeight={'bold'} fontSize={17}>
                      {t('TOTAL')}: ${formatCurrency(+elem.total)}
                    </Typography>
                  </div>
                </div>

                <Table
                  sx={{
                    [`& .${tableCellClasses.root}`]: {
                      fontSize: 14,
                      borderBottom: 2,
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingRight: 0,
                    },
                  }}
                >
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#2c2e35' }}>
                      <TableCell
                        width={'90px'}
                        sx={{ color: 'white', paddingLeft: '8px' }}
                      >
                        {t('TICKET_HASTAG')}
                      </TableCell>
                      <TableCell
                        width={'90px'}
                        sx={{ color: 'white', paddingLeft: 0 }}
                      >
                        {t('SCALE_HASTAG')}
                      </TableCell>
                      <TableCell
                        width={'90px'}
                        sx={{ color: 'white', paddingLeft: 0 }}
                      >
                        {t('DATE')}
                      </TableCell>
                      <TableCell
                        width={'90px'}
                        sx={{ color: 'white', paddingLeft: 0 }}
                      >
                        {t('MATERIAL')}
                      </TableCell>
                      <TableCell
                        width={'90px'}
                        sx={{ color: 'white', paddingLeft: 0 }}
                      >
                        {t('UNIT')}
                      </TableCell>
                      {elem.details.commissions ? (
                        <TableCell
                          width={'90px'}
                          sx={{ color: 'white', paddingLeft: 0 }}
                        >
                          {t('QTY')}
                        </TableCell>
                      ) : (
                        <TableCell
                          width={'90px'}
                          sx={{ color: 'white', paddingLeft: 0 }}
                        >
                          {t('DURATION')}
                        </TableCell>
                      )}
                      {elem.details.commissions ? (
                        <TableCell
                          width={'90px'}
                          sx={{ color: 'white', paddingLeft: 0 }}
                        >
                          {t('UNIT_COST')}
                        </TableCell>
                      ) : (
                        <TableCell
                          width={'90px'}
                          sx={{ color: 'white', paddingLeft: 0 }}
                        >
                          {t('RATE')}
                        </TableCell>
                      )}

                      <TableCell
                        width={'90px'}
                        sx={{ color: 'white', paddingLeft: 0 }}
                      >
                        {t('TOTAL')}
                      </TableCell>
                      <TableCell
                        width={'90px'}
                        sx={{ color: 'white', paddingLeft: 0 }}
                      ></TableCell>
                      <TableCell
                        width={'30px'}
                        sx={{ color: 'white', paddingLeft: 0 }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {elem[elem.job_no].map((instance, i) => {
                      return (
                        <ErrorBoundary>
                          <TableRow key={i}>
                            <TableCell
                              align='left'
                              width={'90px'}
                              sx={{ paddingLeft: '8px' }}
                            >
                              {instance.tk_no}
                            </TableCell>
                            <TableCell
                              align='left'
                              width={'90px'}
                              sx={{ paddingLeft: 0 }}
                            >
                              {instance.scale_no}
                            </TableCell>
                            <TableCell
                              align='left'
                              width={'90px'}
                              sx={{ paddingLeft: 0 }}
                            >
                              {moment(
                                (instance.date_created).split('T')[0]
                              ).format('MM/DD')}
                            </TableCell>
                            <TableCell
                              align='left'
                              width={'90px'}
                              sx={{ marginLeft: 5, paddingLeft: 0 }}
                            >
                              {elem.details.material}
                            </TableCell>
                            <TableCell
                              align='left'
                              width={'90px'}
                              sx={{ paddingLeft: 0 }}
                            >
                              {elem.details.unit}
                            </TableCell>
                            {elem.details.commissions ? (
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                {instance.qty}
                              </TableCell>
                            ) : (
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                {instance.duration}
                              </TableCell>
                            )}
                            {elem.details.commissions ? (
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                {formatCurrency(+instance.unit_cost)}
                              </TableCell>
                            ) : (
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                {formatCurrency(+elem.details.job_hourly_rate)}
                              </TableCell>
                            )}
                            {instance.wait_time ? (
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                ${instance?.ticket_commission}
                              </TableCell>
                            ) : (
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                $
                                {formatCurrency(+instance.commission)}
                              </TableCell>
                            )}

                            <TableCell
                              align='left'
                              width={'90px'}
                              sx={{ paddingLeft: 0 }}
                            >
                              {instance.billed_to_customer === false ? (
                                <ErrorOutlineOutlinedIcon
                                  sx={{ color: 'red', fontSize: 18 }}
                                />
                              ) : null}
                            </TableCell>
                            {instance.wait_time ? (
                              <TableCell
                                align='left'
                                width={'30px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                WT
                              </TableCell>
                            ) : (
                              <TableCell
                                align='left'
                                width={'30px'}
                                sx={{ paddingLeft: 0 }}
                              ></TableCell>
                            )}
                          </TableRow>

                          {instance.wait_time && instance.wait_time_duration ? (
                            <TableRow>
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: '8px' }}
                              >
                                {instance.tk_no}
                              </TableCell>
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                {instance.scale_no}
                              </TableCell>
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                {moment(
                                  (instance.date_created).split('T')[0]
                                ).format('MM/DD')}
                              </TableCell>
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ marginLeft: 5, paddingLeft: 0 }}
                              >
                                Wait Time
                              </TableCell>
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                Hrs:MM
                              </TableCell>
                              {elem.details.commissions ? (
                                <TableCell
                                  align='left'
                                  style={{ width: '140px' }}
                                  sx={{ paddingLeft: 0 }}
                                >
                                  {instance.wait_time_duration}
                                </TableCell>
                              ) : (
                                <TableCell
                                  align='left'
                                  style={{ width: '140px' }}
                                  sx={{ paddingLeft: 0 }}
                                >
                                  {instance.wait_time_duration}
                                </TableCell>
                              )}
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              ></TableCell>
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                ${instance?.wait_time_earnings}
                              </TableCell>
                              <TableCell
                                align='left'
                                width={'90px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                {instance.billed_to_customer === false ? (
                                  <ErrorOutlineOutlinedIcon
                                    sx={{ color: 'red', fontSize: 18 }}
                                  />
                                ) : null}
                              </TableCell>
                              <TableCell
                                align='left'
                                width={'30px'}
                                sx={{ paddingLeft: 0 }}
                              >
                                WT
                              </TableCell>
                            </TableRow>
                          ) : null}
                        </ErrorBoundary>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </ErrorBoundary>
          );
        })}
      </Box>
    </div>
  );
};

const AdditionsTable = ({ data }) => {
  const { t } = useTranslation('navigation');

  return data.additions.bonus.length > 0 ? (
    <div className='flex flex-col items-center justify-center'>
      <ErrorBoundary>
        <Box width={684} sx={{ marginTop: 1 }}>
          <Box
            className='job'
            border={2}
            borderBottom={0}
            sx={{ marginBottom: 1 }}
          >
            <AppBar
              className='flex flex-row items-center justify-center'
              position='static'
              elevation={0}
              layout='horizontal'
              sx={{
                height: '100%',
                width: '100%',
                backgroundColor: 'white',
                borderBottom: 2,
              }}
            >
              <div
                style={{
                  paddingLeft: '25px',
                  marginRight: '10px',
                  width: '140px',
                }}
              >
                <Typography fontWeight={'bold'} fontSize={17}>
                  {t('ADDITIONS')}
                </Typography>
              </div>
            </AppBar>

            <AppBar
              className='flex flex-row items-center justify-center'
              position='static'
              elevation={0}
              layout='horizontal'
              sx={{ height: '100%', width: '100%', backgroundColor: 'white' }}
            >
              <div
                style={{
                  paddingLeft: '25px',
                  marginRight: '10px',
                  width: '140px',
                }}
              >
                <Typography fontWeight={'bold'} fontSize={17}>
                  {moment(data.additions.start).format('MMM DD, YYYY')}
                </Typography>
              </div>
              <div style={{ width: '32px' }}>
                <Typography fontWeight={'bold'} fontSize={17}>
                  {t('TO_LOWER')}
                </Typography>
              </div>
              <div style={{ width: '140px' }}>
                <Typography fontWeight={'bold'} fontSize={17}>
                  {moment(data.additions.end).format('MMM DD, YYYY')}
                </Typography>
              </div>
            </AppBar>
            <Table
              sx={{
                [`& .${tableCellClasses.root}`]: {
                  fontSize: 14,
                  borderBottom: 2,
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingRight: 0,
                },
              }}
            >
              <TableHead>
                <TableRow style={{ backgroundColor: '#2c2e35' }}>
                  <TableCell
                    width={'30px'}
                    sx={{ color: 'white', paddingLeft: '8px' }}
                  >
                    {t('ENTRY_DATE')}
                  </TableCell>
                  <TableCell
                    width={'200px'}
                    sx={{ color: 'white', paddingLeft: 0 }}
                  >
                    {t('REASON')}
                  </TableCell>
                  <TableCell
                    width={'30px'}
                    sx={{ color: 'white', paddingLeft: 0 }}
                  >
                    {t('AMOUNT')}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.additions.bonus.map((elem, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell
                        align='left'
                        width={'10px'}
                        sx={{ paddingLeft: '8px' }}
                      >
                        {moment(elem.entry_date.split('T')[0]).format('MM/DD')}
                      </TableCell>
                      <TableCell
                        align='left'
                        width={'200'}
                        sx={{ paddingLeft: 0 }}
                      >
                        {elem.reason}
                      </TableCell>
                      <TableCell
                        align='left'
                        width={'30px'}
                        sx={{ paddingLeft: 0 }}
                      >
                        ${formatCurrency(+elem.pay)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </ErrorBoundary>
    </div>
  ) : null;
};

const DeductionsTable = ({ data }) => {
  const { t } = useTranslation('navigation');

  return data.deductions.unbonus.length > 0 ? (
    <div className='flex flex-col items-center justify-center'>
      <ErrorBoundary>
        <Box width={684} sx={{ marginTop: 1 }}>
          <Box
            className='job'
            border={2}
            borderBottom={0}
            sx={{ marginBottom: 1 }}
          >
            <AppBar
              className='flex flex-row items-center justify-center'
              position='static'
              elevation={0}
              layout='horizontal'
              sx={{
                height: '100%',
                width: '100%',
                backgroundColor: 'white',
                borderBottom: 2,
              }}
            >
              <div
                style={{
                  paddingLeft: '25px',
                  marginRight: '10px',
                  width: '140px',
                }}
              >
                <Typography fontWeight={'bold'} fontSize={17}>
                  {t('DEDUCTIONS')}
                </Typography>
              </div>
            </AppBar>

            <AppBar
              className='flex flex-row items-center justify-center'
              position='static'
              elevation={0}
              layout='horizontal'
              sx={{ height: '100%', width: '100%', backgroundColor: 'white' }}
            >
              <div
                style={{
                  paddingLeft: '25px',
                  marginRight: '10px',
                  width: '140px',
                }}
              >
                <Typography fontWeight={'bold'} fontSize={17}>
                  {moment(data.deductions.start).format('MMM DD, YYYY')}
                </Typography>
              </div>
              <div style={{ width: '32px' }}>
                <Typography fontWeight={'bold'} fontSize={17}>
                  {t('TO_LOWER')}
                </Typography>
              </div>
              <div style={{ width: '140px' }}>
                <Typography fontWeight={'bold'} fontSize={17}>
                  {moment(data.deductions.end).format('MMM DD, YYYY')}
                </Typography>
              </div>
            </AppBar>
            <Table
              sx={{
                [`& .${tableCellClasses.root}`]: {
                  fontSize: 14,
                  borderBottom: 2,
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingRight: 0,
                },
              }}
            >
              <TableHead>
                <TableRow style={{ backgroundColor: '#2c2e35' }}>
                  <TableCell
                    width={'30px'}
                    sx={{ color: 'white', paddingLeft: '8px' }}
                  >
                    {t('ENTRY_DATE')}
                  </TableCell>
                  <TableCell
                    width={'200px'}
                    sx={{ color: 'white', paddingLeft: 0 }}
                  >
                    {t('REASON')}
                  </TableCell>
                  <TableCell
                    width={'30px'}
                    sx={{ color: 'white', paddingLeft: 0 }}
                  >
                    {t('AMOUNT')}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.deductions.unbonus.map((elem, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell
                        align='left'
                        width={'10px'}
                        sx={{ paddingLeft: '8px' }}
                      >
                        {moment(elem.entry_date.split('T')[0]).format('MM/DD')}
                      </TableCell>
                      <TableCell
                        align='left'
                        width={'200'}
                        sx={{ paddingLeft: 0 }}
                      >
                        {elem.reason}
                      </TableCell>
                      <TableCell
                        align='left'
                        width={'30px'}
                        sx={{ paddingLeft: 0 }}
                      >
                        (${formatCurrency(+elem.pay)})
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </ErrorBoundary>
    </div>
  ) : null;
};

const DayTotals_BlocksFormat = (weekday, date, totals, data) => {
  const { t } = useTranslation('navigation');

  var block_name = '';
  var hours = '';
  if (date) {
    var found = totals.find((elem) => elem.day == date);
    if (found) {
      block_name = found.week_day;
      let total_hours =
        +found.regular_time.split(':')[0] + +found.over_time.split(':')[0];
      let total_minutes =
        +found.regular_time.split(':')[1] + +found.over_time.split(':')[1];
      while (total_minutes >= 60) {
        total_minutes = total_minutes - 60;
        total_hours = total_hours + 1;
      }
      hours = total_hours + ':' + total_minutes;
    } else {
      block_name = moment(date).format('dddd');
      hours = '00:00';
    }
  }
  if (weekday == 'Total') {
    block_name = t('TOTAL');
    hours = data.total_hours;
  }
  if (weekday == 'OverTime') {
    block_name = t('OVERTIME');
    hours = data.ot_hours + ':' + data.ot_minutes;
  }

  return (
    <Table
      sx={{
        [`& .${tableCellClasses.root}`]: {
          borderBottom: 'none',
          padding: 0,
          margin: 0,
          color: 'white',
          alignContent: 'center',
        },
      }}
    >
      <TableHead>
        <TableRow>
          {weekday != 'blank' ? (
            <TableCell sx={{ fontSize: 22, fontWeight: 'bold' }}>
              {hours}
            </TableCell>
          ) : null}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {weekday != 'blank' ? <TableCell>{block_name}</TableCell> : null}
        </TableRow>
      </TableBody>
    </Table>
  );
};
function subtractTime(time1, time2) {
  let result1 = time1.split(':');
  let result2 = time2.split(':');

  if (+result2[0] > 0) {
    result1[0] = +result1[0] - +result2[0];
  }
  result1[1] = +result1[1] - +result2[1];
  if (+result1[1] < 0) {
    result1[0] = +result1[0] - 1;
    result1[1] = +result1[1] + 60;
  }
  return result1;
}

function NetTimePay(data) {
  console.log('DATA', data);
  let obj = {
    time: '',
    wage: data?.rate,
    money: '',
  };
  let d_time;
  let t_hours;
  let hours;
  if (data.drive_time != false) {
    if (data?.drive_time?.split(':')[1].length == 1) {
      d_time =
        data?.drive_time?.split(':')[0] +
        ':0' +
        data?.drive_time?.split(':')[1];
    } else {
      d_time = data.drive_time;
    }
  } else {
    d_time = '00:00';
  }

  if (data.total_hours?.split?.(':')?.[1]?.length == 1) {
    t_hours =
      data.total_hours.split(':')[0] + ':0' + data.total_hours.split(':')[1];
  } else {
    t_hours = data.total_hours || '00:00';
  }
  console.log('NET TIME HERE >> ', subtractTime(d_time, t_hours));
  let new_time = subtractTime(d_time, t_hours);
  if (new_time[0].toString().length == 1) {
    hours = '0' + new_time[0];
  } else {
    hours = new_time[0];
  }
  if (new_time[1].toString().length == 1) {
    hours = hours + ':' + '0' + new_time[1];
  } else {
    hours = hours + ':' + new_time[1];
  }
  obj.time = hours;
  obj.money = (+hours[0] * data.rate + +hours[1] * (data.rate / 60)).toFixed(2);
  console.log(obj.money);

  return obj;
}

const DayTotals_ListFormat = (weekday, date, totals, data) => {
  const { t } = useTranslation('navigation');

  console.log('THE DATE', date);
  var block_name = '';
  var hours = '';
  var dt = false;
  let display_first_shift = false;
  if (date) {
    var found = totals.find((elem) => elem.day == date);
    if (found) {
      //here to access day_summary
      block_name = found.week_day;
      let total_hours =
        +found.regular_time.split(':')[0] + +found.over_time.split(':')[0];
      let total_minutes =
        +found.regular_time.split(':')[1] + +found.over_time.split(':')[1];
      while (total_minutes >= 60) {
        total_minutes = total_minutes - 60;
        total_hours = total_hours + 1;
      }
      hours =
        (total_hours.toString().length == 1 ? '0' + total_hours : total_hours) +
        ':' +
        (total_minutes.toString().length == 1
          ? '0' + total_minutes
          : total_minutes);
      hours = sanitizeReportDuration(hours, '23:59');

      dt = formatDriveTimeParts(found.start_end?.drive_time);
      dt = sanitizeReportDuration(dt, '23:59');
    } else {
      if (data?.first_shift?.date == date) {
        display_first_shift = true;
      }
      block_name = moment(date).format('dddd');
      hours = '00:00';
    }
  }

  if (weekday == 'Total') {
    //data is object batch
    block_name = `${t('TOTAL_DRIVE_TIME')}:`;
    const totalHours = data?.total_hours || '00:00';
    const totalParts = String(totalHours).split(':');
    if ((totalParts[1] || '').length == 1) {
      const pt2 = '0' + totalParts[1];
      if ((totalParts[0] || '').length == 1) {
        const pt1 = '0' + totalParts[0];
        hours = pt1 + ':' + pt2;
      } else {
        hours = (totalParts[0] || '00') + ':' + pt2;
      }
    } else {
      if ((totalParts[0] || '').length == 1) {
        const pt1 = '0' + totalParts[0];
        hours = pt1 + ':' + (totalParts[1] || '00');
      } else {
        hours = totalHours;
      }
    }
  }
  if (weekday == 'OverTime') {
    block_name = `${t('OVERTIME')}:`;

    hours = `${padTimePart(data?.ot_hours)}:${padTimePart(data?.ot_minutes)}`;
  }
  if (weekday == 'drive_time') {
    block_name = `${t('TOTAL_TIME_CLOCK')}:`;
    if (data.drive_time != false) {
      if (data.drive_time?.split(':')[1].length == 1) {
        hours =
          data?.drive_time?.split(':')[0] +
          ':0' +
          data?.drive_time?.split(':')[1];
      } else {
        hours = data.drive_time;
      }
    } else {
      hours = '00:00';
    }
  }
  if (weekday == 'net') {
    block_name = `${t('NET_WORKED_HOURS')}:`;
    let d_time;
    let t_hours;
    if (data.drive_time != false) {
      if (data?.drive_time?.split(':')[1].length == 1) {
        d_time =
          data?.drive_time?.split(':')[0] +
          ':0' +
          data?.drive_time?.split(':')[1];
      } else {
        d_time = data.drive_time;
      }
    } else {
      d_time = '00:00';
    }

    if (data.total_hours?.split?.(':')?.[1]?.length == 1) {
      t_hours =
        data.total_hours.split(':')[0] + ':0' + data.total_hours.split(':')[1];
    } else {
      t_hours = data.total_hours || '00:00';
    }
    console.log('NET TIME HERE >> ', subtractTime(d_time, t_hours));
    let new_time = subtractTime(d_time, t_hours);
    if (new_time[0].toString().length == 1) {
      hours = '0' + new_time[0];
    } else {
      hours = new_time[0];
    }
    if (new_time[1].toString().length == 1) {
      hours = hours + ':' + '0' + new_time[1];
    } else {
      hours = hours + ':' + new_time[1];
    }
  }

  return (
    <ErrorBoundary>
      {
        //wekk day name
        weekday != 'blank' &&
        weekday != 'Total' &&
        weekday != 'drive_time' &&
        weekday != 'OverTime' &&
        weekday != 'net' ? (
          <TableCell
            align='left'
            width={'120px'}
            sx={{
              paddingBottom: 1,
              padding: 0,
              margin: 0,
              paddingLeft: 1,
              fontSize: 15,
              fontWeight: 'bold',
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {block_name}
          </TableCell>
        ) : null
      }
      {weekday != 'blank' &&
      weekday != 'Total' &&
      weekday != 'drive_time' &&
      weekday != 'OverTime' &&
      weekday != 'net' ? (
        //clok in and out
        found ? (
          <TableCell
            align='left'
            width={'100px'}
            sx={{
              fontSize: 13,
              padding: 0,
              paddingLeft: 1,
              paddingRight: 1,
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {sanitizeReportClockLabel(found.start_end?.start, '12:00 AM')}-
            {sanitizeReportClockLabel(found.start_end?.end, '11:59 PM')}
          </TableCell>
        ) : (
          <TableCell
            align='left'
            width={'100px'}
            sx={{
              fontSize: 13,
              padding: 0,
              paddingLeft: 1,
              paddingRight: 1,
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {display_first_shift ? data?.first_shift.time : '00:00'}--00:00
          </TableCell>
        )
      ) : null}
      {weekday != 'blank' &&
      weekday != 'Total' &&
      weekday != 'drive_time' &&
      weekday != 'OverTime' &&
      weekday != 'net' ? (
        //drive time
        found ? (
          <TableCell
            align='left'
            width={'40px'}
            sx={{
              fontSize: 13,
              padding: 0,
              paddingRight: 1,
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {formatTimeWithWarning(sanitizeReportDuration(dt ? dt : null, '23:59'))}
          </TableCell>
        ) : (
          <TableCell
            align='left'
            width={'40px'}
            sx={{
              fontSize: 13,
              padding: 0,
              paddingRight: 1,
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {formatTimeWithWarning('00:00')}
          </TableCell>
        )
      ) : null}

      {
        //comp time
        weekday != 'blank' &&
        weekday != 'Total' &&
        weekday != 'drive_time' &&
        weekday != 'OverTime' &&
        weekday != 'net' ? (
          <TableCell
            width={'40px'}
            sx={{
              fontSize: 12,
              padding: 0,
              paddingRight: 1,
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {formatTimeWithWarning(sanitizeReportDuration(hours, '23:59'))}
          </TableCell>
        ) : null
      }

      {
        //totals box name
        weekday == 'Total' || weekday == 'drive_time' ? (
          <TableCell
            width={'160px'}
            height={'20px'}
            sx={{
              paddingBottom: 1,
              padding: 0,
              margin: 0,
              paddingRight: 2,
              fontSize: 15,
              fontWeight: 'bold',
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {block_name}
          </TableCell>
        ) : null
      }

      {
        //net box name
        weekday == 'net' ? (
          <TableCell
            width={'170px'}
            height={'20px'}
            align='left'
            sx={{
              padding: 0,
              margin: 0,
              paddingLeft: 0.8,
              marginRight: 0.1,
              fontSize: 15,
              fontWeight: 'bold',
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {block_name}
          </TableCell>
        ) : null
      }

      {
        //OverTime box name
        weekday == 'OverTime' ? (
          <TableCell
            width={'160px'}
            height={'20px'}
            sx={{
              paddingBottom: 1,
              padding: 0,
              margin: 0,
              paddingRight: 2,
              fontSize: 15,
              fontWeight: 'bold',
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {block_name}
          </TableCell>
        ) : null
      }

      {
        //totals box values
        weekday == 'Total' ||
        weekday == 'drive_time' ||
        weekday == 'OverTime' ? (
          <TableCell
            height={'20px'}
            sx={{
              fontSize: 15,
              padding: 0,
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {hours}
          </TableCell>
        ) : null
      }
      {
        //totals box values
        weekday == 'net' ? (
          <TableCell
            align='left'
            height={'20px'}
            sx={{
              fontSize: 15,
              padding: 0,
              paddingRight: 1,
              marginRight: 0.2,
              borderBottom: 'none',
              color: 'black',
            }}
          >
            {hours}
          </TableCell>
        ) : null
      }
    </ErrorBoundary>
  );
};

const TimeTable = ({ data, extra_data }) => {
  //use extra_data.days to get first and last day of pay period
  const state = store.getState();
  const companyLogo = extra_data.complogo;
  var happend = false;
  const { t } = useTranslation('navigation');
  return (
    <div className='page-break-before flex flex-col items-center justify-center earning-print'>
      <ErrorBoundary>
        <div className='flex flex-col'>
          <div className='flex flex-row items-end justify-end'>
            {companyLogo ? <img width='200px' src={companyLogo} /> : null}
          </div>

          <div className='flex flex-row'>
            <div className='flex flex-col' style={{ width: '342px' }}>
              <Typography fontSize={24} fontWeight={'bold'} color={'black'}>
                {extra_data.name}
              </Typography>
              <Typography fontSize={18} color={'black'}>
                {extra_data.driver_address}
              </Typography>
            </div>

            <div
              className='flex flex-row items-end justify-end'
              style={{ width: '342px' }}
            >
              <Typography fontSize={18} fontWeight={'bold'}>
                {t('TOTAL_EARNINGS')}:
              </Typography>
              &nbsp;
              <Typography fontSize={18}>
                $
                {formatCurrency(
                  +extra_data.additions_total +
                    +extra_data.commission_total -
                    +extra_data.deductions_total
                )}
              </Typography>
            </div>
          </div>
        </div>
        <Box className='flex flex-col items-center mt-5' sx={{ border: 2 }}>
          <AppBar
            className='flex flex-row items-center justify-center'
            position='static'
            elevation={0}
            layout='horizontal'
            sx={{
              height: '100%',
              width: '100%',
              backgroundColor: '#2c2e35',
              borderBottom: 2,
            }}
          >
            <div className='pr-160'>
              <Typography
                variant='h5'
                gutterBottom
                color='white'
                fontWeight='bold'
              >
                {t('DRIVER_COMPENSATION')}
              </Typography>
            </div>
            <div className='pr-64'>
              <Typography
                variant='h5'
                gutterBottom
                color='white'
                fontWeight='bold'
              >
                {t('TIME_LOG')}
              </Typography>
            </div>
          </AppBar>

          <div className='flex flex-row items-center justify-center'>
            <Box height={321} width={341} sx={{ borderRight: 1 }}>
              <TableContainer sx={{ paddingTop: 1, overflow: 'hidden' }}>
                <Table
                  sx={{
                    [`& .${tableCellClasses.root}`]: { padding: 0, margin: 0 },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('PAY_PERIOD')}:
                      </TableCell>
                      {extra_data?.days && (
                        <TableCell
                          colSpan={2}
                          style={{
                            paddingRight: 0,
                            borderBottom: 'none',
                            marginLeft: 50,
                          }}
                        >
                          {moment(extra_data?.days[0]).format('MM/DD')} -{' '}
                          {moment(extra_data?.days[6]).format('MM/DD, YYYY')}
                        </TableCell>
                      )}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('HOURLY_RATE')}:
                      </TableCell>
                      <TableCell
                        align='left'
                        style={{ borderBottom: 'none', paddingRight: 50 }}
                      >
                        ${extra_data.rate}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('DRIVE_TIME')}:
                      </TableCell>{' '}
                      <span>
                        <TableCell
                          align='left'
                          width={'5%'}
                          style={{ borderBottom: 'none' }}
                        >
                          $
                          {formatCurrency(
                            +extra_data.reg_hours * +extra_data.rate +
                              +extra_data.reg_minutes * (+extra_data.rate / 60)
                          )}
                        </TableCell>
                        <TableCell
                          align='left'
                          style={{
                            borderBottom: 'none',
                            fontSize: 13,
                            paddingLeft: 2,
                          }}
                        >{`( ${extra_data.rate}*${padTimePart(
                          extra_data.reg_hours,
                          '0'
                        )}:${padTimePart(extra_data.reg_minutes)})`}</TableCell>
                      </span>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('NET_WORKED_HOURS')}:
                      </TableCell>{' '}
                      <span>
                        <TableCell
                          align='left'
                          width={'5%'}
                          style={{ borderBottom: 'none' }}
                        >
                          ${formatCurrency(extra_data?.net_money || 0)}
                        </TableCell>
                        <TableCell
                          align='left'
                          style={{
                            borderBottom: 'none',
                            fontSize: 13,
                            paddingLeft: 2,
                          }}
                        >{`(${NetTimePay(extra_data).time})`}</TableCell>
                      </span>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('OVERTIME')}:
                      </TableCell>
                      <TableCell
                        align='left'
                        style={{ borderBottom: 'none', paddingRight: 50 }}
                      >
                        ${formatCurrency(+extra_data.ot_pay)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('TOTAL_WAGES')}:
                      </TableCell>{' '}
                      <span>
                        <TableCell
                          align='left'
                          width={'5%'}
                          style={{ borderBottom: 'none' }}
                        >
                          $
                          {formatCurrency(
                            +extra_data?.total_pay + +extra_data?.net_money
                          )}
                        </TableCell>
                        <TableCell
                          align='left'
                          style={{
                            borderBottom: 'none',
                            fontSize: 13,
                            paddingLeft: 2,
                          }}
                        >{`(${
                          extra_data?.drive_time != false
                            ? extra_data?.drive_time
                            : '00:00'
                        } hrs)`}</TableCell>
                      </span>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('COMMISSION')}:
                      </TableCell>{' '}
                      <span>
                        <TableCell
                          align='left'
                          width={'5%'}
                          style={{ borderBottom: 'none' }}
                        >
                          $
                          {+extra_data.commission_total - +extra_data.total_pay < 0
                            ? '0.00'
                            : formatCurrency(
                                +extra_data.commission_total - +extra_data.total_pay
                              )}
                        </TableCell>{' '}
                        <TableCell
                          align='left'
                          style={{
                            borderBottom: 'none',
                            fontSize: 13,
                            paddingLeft: 2,
                          }}
                        >{`(${extra_data.commission_percent})`}</TableCell>
                      </span>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          fontWeight: 'bold',
                        }}
                      >
                        {t('SUB_TOTAL')}:
                      </TableCell>{' '}
                      <TableCell align='left' style={{ paddingRight: 50 }}>
                        $
                        {formatCurrency(+extra_data.commission_total)}
                      </TableCell>{' '}
                      <TableCell style={{ borderBottom: 'none' }}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('ADDITIONAL_PAY')}:
                      </TableCell>{' '}
                      <TableCell
                        align='left'
                        style={{ borderBottom: 'none', paddingRight: 50 }}
                      >
                        $
                        {formatCurrency(+extra_data.additions_total)}
                      </TableCell>{' '}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align='left'
                        style={{
                          paddingLeft: 45,
                          fontSize: 15,
                          borderBottom: 'none',
                          fontWeight: 'bold',
                        }}
                      >
                        {t('DEDUCTIONS')}:
                      </TableCell>{' '}
                      <TableCell
                        align='left'
                        style={{ borderBottom: 'none', paddingRight: 50 }}
                      >
                        ($
                        {formatCurrency(+extra_data.deductions_total)}
                        )
                      </TableCell>{' '}
                    </TableRow>
                  </TableHead>
                </Table>
              </TableContainer>
              <Box
                border={0}
                borderTop={2}
                height={'340px'}
                marginTop={'4px'}
                paddingTop={'7px'}
              >
                <Typography paddingLeft={7.5} fontSize={17} fontWeight='bold'>
                  {t('TOTAL_EARNINGS_THIS_PAY')}
                </Typography>
                <span style={{ display: 'flex' }}>
                  <Typography paddingLeft={7.5} fontSize={17} fontWeight='bold'>
                    {t('PERIOD')}:
                  </Typography>
                  &nbsp;
                  <Typography fontSize={17}>
                    $
                    {formatCurrency(
                      +extra_data.additions_total +
                        +extra_data.commission_total -
                        +extra_data.deductions_total
                    )}
                  </Typography>
                </span>
              </Box>
            </Box>

            <Box height={320} width={341} sx={{ borderLeft: 1, paddingTop: 1 }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ padding: 0 }}>
                    <TableCell
                      width={'15%'}
                      sx={{ borderBottom: 0, padding: 0 }}
                    ></TableCell>
                    <TableCell
                      width={'130px'}
                      sx={{
                        padding: 0,
                        border: 0,
                        borderBottom: 1,
                        paddingRight: 0,
                      }}
                    >
                      {t('CLOCK_IN_CLOCK_OUT')}
                    </TableCell>
                    <TableCell
                      width={'10px'}
                      sx={{
                        padding: 0,
                        border: 0,
                        borderBottom: 1,
                        paddingLeft: '0px',
                      }}
                    >
                      {t('TIME_CLOCK')}
                    </TableCell>
                    <TableCell
                      width={'10px'}
                      sx={{
                        padding: 0,
                        border: 0,
                        borderBottom: 1,
                        paddingLeft: '0px',
                      }}
                    >
                      {t('DRIVE_TIME')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow sx={{ padding: 0 }}>
                    {' '}
                    {extra_data?.days
                      ? DayTotals_ListFormat(
                          'Monday',
                          extra_data.days[0],
                          extra_data.day_summary,
                          extra_data
                        )
                      : ''}
                  </TableRow>
                  <TableRow sx={{ padding: 0 }}>
                    {extra_data?.days
                      ? DayTotals_ListFormat(
                          'Tuesday',
                          extra_data.days[1],
                          extra_data.day_summary,
                          extra_data
                        )
                      : ''}
                  </TableRow>
                  <TableRow sx={{ padding: 0 }}>
                    {extra_data?.days
                      ? DayTotals_ListFormat(
                          'Wednesday',
                          extra_data.days[2],
                          extra_data.day_summary,
                          extra_data
                        )
                      : ''}
                  </TableRow>

                  <TableRow sx={{ padding: 0 }}>
                    {extra_data?.days
                      ? DayTotals_ListFormat(
                          'Thursday',
                          extra_data.days[3],
                          extra_data.day_summary,
                          extra_data
                        )
                      : ''}
                  </TableRow>
                  <TableRow sx={{ padding: 0 }}>
                    {extra_data?.days
                      ? DayTotals_ListFormat(
                          'Friday',
                          extra_data.days[4],
                          extra_data.day_summary,
                          extra_data
                        )
                      : ''}
                  </TableRow>
                  <TableRow sx={{ padding: 0 }}>
                    {extra_data?.days
                      ? DayTotals_ListFormat(
                          'Saturday',
                          extra_data.days[5],
                          extra_data.day_summary,
                          extra_data
                        )
                      : ''}
                  </TableRow>

                  <TableRow sx={{ padding: 0 }}>
                    {extra_data?.days
                      ? DayTotals_ListFormat(
                          'Sunday',
                          extra_data.days[6],
                          extra_data.day_summary,
                          extra_data
                        )
                      : ''}
                  </TableRow>
                  {extra_data?.days && extra_data?.days[7] ? (
                    <TableRow sx={{ padding: 0 }}>
                      {extra_data?.days
                        ? DayTotals_ListFormat(
                            'Monday',
                            extra_data.days[7],
                            extra_data.day_summary,
                            extra_data
                          )
                        : ''}
                    </TableRow>
                  ) : (
                    <TableRow sx={classes.blank}>
                      {DayTotals_ListFormat('blank')}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <Box
                border={0}
                borderTop={2}
                height={'340px'}
                paddingTop={'5px'}
                marginTop={'32px'}
              >
                <Grid container item xs={12}>
                  <Grid item xs={12}>
                    <Paper sx={classes.paper}>
                      {DayTotals_ListFormat('drive_time', '', [], extra_data)}
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper sx={classes.paper}>
                      {DayTotals_ListFormat('Total', '', [], extra_data)}
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper sx={classes.paper}>
                      {DayTotals_ListFormat('net', '', [], extra_data)}
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper sx={classes.paper}>
                      {DayTotals_ListFormat('OverTime', '', [], extra_data)}
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </div>
        </Box>
      </ErrorBoundary>
    </div>
  );
};

const CombineTables = ({ time_data, data, extra_data, index }) => {
  return (
    <div key={index}>
      <TimeTable data={time_data} extra_data={extra_data} />
      <JobTable data={data} />
      <AdditionsTable data={extra_data} />
      <DeductionsTable data={extra_data} />
    </div>
  );
};

const reportHasUnbilledTicket = (reports) =>
  reports.some((report) =>
    (report?.data || []).some((job) =>
      (job?.[job.job_no] || []).some(
        (ticket) => ticket?.billed_to_customer === false
      )
    )
  );

const UserTable = () => {
  const { t } = useTranslation('navigation');
  const showUnbilledNote = reportHasUnbilledTicket(ReportData);
  //the div was neccessary to create all the tables for both users
  return (
    <div>
      <style>{`
        @media print {
          @page {
            margin-bottom: 16mm !important;
          }
          .earning-report-footer {
            display: flex !important;
            position: fixed !important;
            right: 8mm !important;
            bottom: 4mm !important;
            align-items: center !important;
            justify-content: flex-end;
            width: auto !important;
            height: auto !important;
            margin: 0 !important;
            padding: 0 !important;
            background: transparent !important;
            z-index: 50;
          }
          .earning-report-footer .MuiTypography-root,
          .earning-report-footer img {
            margin-top: 0 !important;
          }
        }
      `}</style>
      <div className='Report'>
        {ReportData.length > 0
          ? ReportData.map((elem, index) => {
              return (
                <ErrorBoundary>
                  <CombineTables
                    index={index}
                    extra_data={elem}
                    time_data={elem.time_data}
                    data={elem.data}
                  />
                </ErrorBoundary>
              );
            })
          : null}
        {showUnbilledNote ? (
          <div className='flex flex-col items-center justify-center'>
            <Box
              width={684}
              sx={{
                display: 'flex',
                alignItems: 'center',
                color: 'red',
                marginTop: 2,
                marginBottom: 1,
              }}
            >
              <ErrorOutlineOutlinedIcon sx={{ color: 'red', fontSize: 18 }} />
              <Typography sx={{ color: 'red', fontSize: 14 }}>
                : This ticket is not billed to the customer
              </Typography>
            </Box>
          </div>
        ) : null}
      </div>
      <div className='earning-report-footer'>
        <Typography fontSize={15} sx={{ marginTop: 1, marginRight: 1 }}>
          {t('POWERED_BY')}
        </Typography>
        <img
          style={{ width: 80, height: 20, marginTop: 7 }}
          src='assets/images/logos/loadzlogo.png'
        />
      </div>
    </div>
  );
};

export default class EarningsReport extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    ReportData = [];
    if (this.props) {
      if (this.props?.id) {
        var timesheets = this.props.timesheets?.find(
          (elem) => elem.id == this.props?.id
        );
        timesheets = [timesheets];
      } else {
        var timesheets = this.props.timesheets;
      }

      for (const earnings_user of this.props.earnings) {
        const idx = this.props.earnings.indexOf(earnings_user);
        createData(earnings_user, timesheets[0], this.props.batch_access);
      }
      return <UserTable />;
    }
  }
}
